import { SpeakerInfo, SpeakerMonologue } from './types';
import { Word } from '@/domains/transcript';
import { SpeakerWithDetails } from '@/context/TranscriptContext/TranscriptContextTypes';
import { getSpeakerColorAttributes } from '@/context/TranscriptContext/TranscriptContextUtils';

export function groupWordsBySpeaker(words: Word[]): SpeakerMonologue[] {
  const monologues: SpeakerMonologue[] = [];
  let currentMonologue: SpeakerMonologue | null = null;

  words.forEach(word => {
    if (!currentMonologue || currentMonologue.speakerLabel !== word.speaker_label) {
      if (currentMonologue) {
        monologues.push(currentMonologue);
      }
      currentMonologue = {
        speakerLabel: word.speaker_label,
        text: '',
        words: []
      };
    }

    currentMonologue.text += (currentMonologue.text ? ' ' : '') + word.content;
    currentMonologue.words.push(word);
  });

  if (currentMonologue) {
    monologues.push(currentMonologue);
  }

  return monologues;
}

export function mapSpeakersToInfo(
  captions: Word[],
  speakers: Record<string, SpeakerWithDetails>
): Record<string, SpeakerInfo> {
  const speakerMap: Record<string, SpeakerInfo> = {};
  const uniqueSpeakers = new Set<string>();

  captions.forEach(caption => {
    if (caption.speaker_label && !uniqueSpeakers.has(caption.speaker_label)) {
      uniqueSpeakers.add(caption.speaker_label);
    }
  });

  Array.from(uniqueSpeakers).forEach((speakerLabel, index) => {
    const speaker = speakers?.[speakerLabel];

    if (speaker) {
      const fullName = `${speaker.first_name || ''} ${speaker.last_name || ''}`.trim();
      speakerMap[speakerLabel] = {
        name: fullName || `Speaker ${index + 1}`,
        profile_picture_url: speaker.profile_picture_url,
        bgColor: speaker.bgColor,
        color: speaker.color,
        lightBgColor: speaker.lightBgColor,
        hoverBgColor: speaker.hoverBgColor
      };
    } else {
      const colorAttributes = getSpeakerColorAttributes(index);
      speakerMap[speakerLabel] = {
        name: `Speaker ${index + 1}`,
        ...colorAttributes
      };
    }
  });

  return speakerMap;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
